export function getStreamUrl(
  baseUrl,
  authToken,
  accountServerInfoProvider,
  accountNumber
) {
  if (!authToken) {
    return '';
  }
  return `${baseUrl}/${authToken}/${accountServerInfoProvider}/${accountNumber}`;
}
